import { createFileRoute } from "@tanstack/react-router"
import NewsEditor from "../../../components/News/NewsEditor"

export const Route = createFileRoute("/_layout/news/create")({
  component: NewsEditor,
})
